import React from 'react';
import { InputTuKhoa } from 'modules/reception/form-timkiem';
import { Button } from '@blueprintjs/core';
import { Link } from 'react-router';
import { DropDownChonLoaiDonThu, DropDownChonHuongXuLy } from 'components/tt-forms';
import { DatePicker } from 'components/tt-forms/common';

let classNames = require('classnames');

class FormTimKiemNangCao extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      searchKey: '',
      receptionType: '',
      handleRedirect: '',
      startDate: '',
      endDate: '',

      searching: this.props.disabled,

      spSearch: false,
      search: false,
      doSearch: false,
      searchLoading: false
    };
  }

  componentDidMount() {
    let data = localStorage.getItem('tcdtxData') ? JSON.parse(localStorage.getItem('tcdtxData')) : {};
    this.state.searchKey = data.tuKhoa || '';
    if (data.advanceSearch) {
      this.state.receptionType = data.phanLoaiDon || '';
      this.state.handleRedirect = data.huongXuLy || '';
      this.state.startDate = data.startDate ? new Date(data.startDate) : '';
      this.state.endDate = data.endDate ? new Date(data.endDate) : '';
    }
    this.setState({...this.state});
  }

  handleSearch(e) {
    e.preventDefault();

    if (!this.props.advanceSearch) {
      this.setState({
        doSearch: true
      });
      this.props.handleSearch(this.state, e);
    } else {
      if(this.validateSubmitForm()) {
        this.setState({
          doSearch: true
        });
        this.props.handleSearch(this.state, e);
      }
    }

    return;
  }

  validateSubmitForm() {
    let pass = true;
    this.props.validators['formTaoDon'].map(validator => {
      if(pass) {
        pass = validator.validate();
      } else {
        validator.validate();
      }
    });
    return pass;
  }

  componentWillUnmount() {

  }

  cancel(e) {
    this.props.onCancel(e);
  }

  handleChange(name, e) {
    this.setState({[name] : e.target.value});
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      searching: nextProps.disabled,
      doSearch: nextProps.search
    });
  }

  handleChangeDate(name, e) {
    if (e && e._d) {
      this.setState({
        [name]: e._d
      });
    } else {
      this.setState({
        [name]: e
      });
    }
  }

  render() {
    let classes = ['btn-green', 'tt-search'];

    if (this.state.searching) {
      classes.push('btn-disable');

      if (this.state.doSearch) {
        classes.push('btn-loading');
      }
    }

    let btnClasses = classNames(classes);
    // this.state.tableLoading ? (this.state.searching ? "btn-green tt-search btn-loading" : "btn-green tt-search btn-disable") : "btn-green tt-search"
    return (
      <form className="search-form" onSubmit={ this.handleSearch.bind(this) }>
        <InputTuKhoa onChange={ this.handleChange.bind(this, 'searchKey') } value={this.state.searchKey} />
        <DropDownChonLoaiDonThu selectedValue={this.state.receptionType} onChange={ this.handleChange.bind(this, 'receptionType') } />
        <div className="btn-wrap">
          <Button className={ btnClasses } text="Tìm kiếm" type="submit" disabled={ this.state.searching ? 'disabled' : '' } />
        </div>
        <div className=' clear-left'>
          <DatePicker label='Tiếp nhận từ ngày' value={this.state.startDate} bindValidator={this} channel="formTaoDon" endDate={ this.state.endDate } onChange={ this.handleChangeDate.bind(this, 'startDate') } />
        </div>
        <DatePicker label='Đến ngày' value={this.state.endDate} bindValidator={this} channel="formTaoDon" startDate={ this.state.startDate } onChange={ this.handleChangeDate.bind(this, 'endDate') } />
        <DropDownChonHuongXuLy selected={this.state.handleRedirect} onChange={ this.handleChange.bind(this, 'handleRedirect') } />
        <div className="input-group">
          <Link className={ this.state.tableLoading ? "disable-super-search btn-disable-transparent" : "disable-super-search" } onClick={ this.cancel.bind(this) }><i className="tt tt-delete"></i>Hủy tìm kiếm nâng cao</Link>
        </div>
      </form>
    );
  }
}

FormTimKiemNangCao.defaultProps = {
  validators: {},
  handleSearch: function() {
    console.log('Please assign handleSearch() method');
  },

  disabled: false,
  searching: false
}

export default FormTimKiemNangCao;



// WEBPACK FOOTER //
// ./src/components/modules/reception/form-timkiem/form-nangcao.js